const personIcon = `
  <svg class="field__icon" aria-hidden="true" viewBox="0 0 24 24" fill="none">
    <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm7 8a7 7 0 0 0-14 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>`;

const emailIcon = `
  <svg class="field__icon" aria-hidden="true" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
    <path d="m4 7 8 6 8-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

const arrowIcon = `
  <svg class="cta__arrow" aria-hidden="true" viewBox="0 0 24 24" fill="none">
    <path d="M5 12h14m-5-5 5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

export function notifyTemplate(instanceId: string): string {
  return `
    <section class="card" aria-labelledby="${instanceId}-title">
      <h2 class="title" id="${instanceId}-title">Notify me when available</h2>
      <p class="help">Leave your details and we’ll let you know when this service is ready.</p>
      <form novalidate>
        <div class="field">
          <label class="field__label" for="${instanceId}-name">Name <span class="field__req">*</span></label>
          <div class="field__control">
            ${personIcon}
            <input id="${instanceId}-name" name="name" type="text" autocomplete="name" maxlength="100" placeholder="Enter your name" aria-describedby="${instanceId}-name-error" required>
          </div>
          <p class="error" id="${instanceId}-name-error" data-error-for="name" aria-live="polite"></p>
        </div>
        <div class="field">
          <label class="field__label" for="${instanceId}-email">Email <span class="field__req">*</span></label>
          <div class="field__control">
            ${emailIcon}
            <input id="${instanceId}-email" name="email" type="email" autocomplete="email" maxlength="254" placeholder="Enter your email" aria-describedby="${instanceId}-email-error" required>
          </div>
          <p class="error" id="${instanceId}-email-error" data-error-for="email" aria-live="polite"></p>
        </div>
        <button class="cta" type="submit"><span>Notify me</span>${arrowIcon}</button>
        <div class="message" role="status" aria-live="polite"></div>
        <p class="disclaimer">
          We’ll store your details so we can contact you when this service becomes available.
          <a href="https://www.thegpservice.co.uk/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy policy</a>
        </p>
      </form>
    </section>`;
}
